/*window.addEventListener('load', function() {
  console.log('Window fully loaded');

  // Function to handle the mouseover and mouseleave events for updating/hiding the image
  function handleMenuItems() {
    const menuItems = document.querySelectorAll('li.t4s-menu-item[data-collection-image]');
    console.log('Menu items with data-collection-image:', menuItems.length);

    if (menuItems.length === 0) {
      console.log('No <li> elements with data-collection-image found.');
      return;  // Exit if no menu items are found
    }
      
    menuItems.forEach(item => {
      item.addEventListener('mouseover', function() {
        console.log('Mouseover event triggered');
        
        // Get the data-collection-image value
        const imageUrl = item.getAttribute('data-collection-image');
        console.log('Original data-collection-image URL:', imageUrl);

        if (imageUrl) {
          // Clean the image URL by prepending https:// if needed
          const cleanedImageUrl = imageUrl.startsWith('//') ? 'https:' + imageUrl : imageUrl;
          console.log('Cleaned data-collection-image URL (final):', cleanedImageUrl);
          
          // Find all mega-menu-image-container divs
          const imageContainers = document.querySelectorAll('.mega-menu-image-container');

          imageContainers.forEach(container => {
            // Check if the container's ID matches the pattern we expect
            const containerId = container.id;
            const itemIdSuffix = item.id.replace('item_mega_', ''); // Get unique suffix from the hovered item
            
            // Check if the container ID ends with the same suffix as the hovered menu item
            if (containerId.endsWith(itemIdSuffix)) {
              console.log(`Found matching container with ID: ${containerId}`);
              
              // Find the img tag inside the matched container
              const imageElement = container.querySelector('img');

              if (imageElement) {
                console.log('Image element found inside mega-menu-image-container');
                
                // Set both src and data-src attributes to handle lazy loading
                imageElement.src = cleanedImageUrl;
                imageElement.setAttribute('data-src', cleanedImageUrl); // In case lazy loading uses data-src
                imageElement.alt = 'Collection Image';
                imageElement.style.display = 'block';  // Make sure image is visible
                console.log('Image src updated to:', imageElement.src);

                // Error handling for image load failure
                imageElement.onerror = function() {
                  console.log('Image failed to load:', cleanedImageUrl);
                  imageElement.style.display = 'none';  // Hide the image if it fails to load
                };
                imageElement.onload = function() {
                  console.log('Image successfully loaded:', cleanedImageUrl);
                };
              } else {
                console.log('Image element not found inside mega-menu-image-container');
              }
            }
          });
        } else {
          console.log('No data-collection-image found');
        }
      });

      // Add mouseleave event listener to hide the image
      item.addEventListener('mouseleave', function() {
        console.log('Mouseleave event triggered');
        
        // Find all mega-menu-image-container divs
        const imageContainers = document.querySelectorAll('.mega-menu-image-container');

        imageContainers.forEach(container => {
          // Check if the container's ID matches the hovered item's ID pattern
          const containerId = container.id;
          const itemIdSuffix = item.id.replace('item_mega_', ''); // Get unique suffix from the hovered item
          
          if (containerId.endsWith(itemIdSuffix)) {
            console.log(`Hiding image in container with ID: ${containerId}`);

            // Find the img tag inside the matched container
            const imageElement = container.querySelector('img');

            if (imageElement) {
              // Hide the image when mouse leaves the item
              imageElement.style.display = 'none';
              console.log('Image hidden.');
            }
          }
        });
      });
    });
  }

  // Initial call in case elements are already present
  handleMenuItems();

  // Mutation observer to check if the image src is being overwritten
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      //console.log('Mutation detected:', mutation);
      if (mutation.attributeName === 'src' || mutation.attributeName === 'data-src') {
        console.log('Image src or data-src attribute changed:', mutation.target.src);
      }
    });
  });

  // Start observing the image container for changes
  const imageContainers = document.querySelectorAll('.mega-menu-image-container');
  imageContainers.forEach(container => {
    const imageElement = container.querySelector('img');
    if (imageElement) {
      observer.observe(imageElement, { attributes: true });
      console.log('Observing changes to the image element in', container.id);
    }
  });
});
*/

/*document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener( "variant:changed", function( evt ) {
    console.log( evt.currentVariant );
    const variant_sku_text_all = document.querySelectorAll('.t4s-sku-value');
    const  variant_sku_text = variant_sku_text_all[variant_sku_text_all - 1];
    console.log(variant_sku_text); 
  });
});
*/
window.addEventListener('load', function() {
  console.log('Window fully loaded');

  // Function to handle the mouseover and mouseleave events for updating/hiding the image
  function handleMenuItems() {
    const menuItems = document.querySelectorAll('li.t4s-menu-item[data-collection-image]');
    
    if (menuItems.length === 0) {
      return;  // Exit if no menu items are found
    }

    menuItems.forEach(item => {
      item.addEventListener('mouseover', function() {
        
        // Get the data-collection-image value
        const imageUrl = item.getAttribute('data-collection-image');

        if (imageUrl) {
          const cleanedImageUrl = imageUrl.startsWith('//') ? 'https:' + imageUrl : imageUrl;
          
          const imageContainers = document.querySelectorAll('.mega-menu-image-container');

          imageContainers.forEach(container => {
            const containerId = container.id;
            const itemIdSuffix = item.id.replace('item_mega_', ''); // Get unique suffix from the hovered item

            // Check if the container ID ends with the same suffix as the hovered menu item
            if (containerId.endsWith(itemIdSuffix)) {
              const imageElement = container.querySelector('img');

              if (imageElement) {
                // Update image src and display
                imageElement.src = cleanedImageUrl;
                imageElement.setAttribute('data-src', cleanedImageUrl);
                imageElement.alt = 'Collection Image';

                // Set width and height to 400px and ensure image is visible
                imageElement.style.setProperty('width', '336px', 'important');
                imageElement.style.setProperty('height', '336px', 'important');
                imageElement.style.display = 'block';

                imageElement.onerror = function() {
                  imageElement.style.display = 'none';
                };
              }

              // Now hide the adjacent div with class 't4s-d-block' and specific ID
              const nextDiv = container.closest('.t4s-sub-menu').querySelector('.t4s-d-block');
              if (nextDiv) {
                nextDiv.style.setProperty('display', 'none', 'important');  // Apply display: none !important
                console.log('Next div with class t4s-d-block is hidden:', nextDiv.id);
              }
            }
          });
        }
      });

      // Add mouseleave event listener to reset
      item.addEventListener('mouseleave', function() {
        const imageContainers = document.querySelectorAll('.mega-menu-image-container');

        imageContainers.forEach(container => {
          const containerId = container.id;
          const itemIdSuffix = item.id.replace('item_mega_', '');

          if (containerId.endsWith(itemIdSuffix)) {
            const imageElement = container.querySelector('img');

            if (imageElement) {
              imageElement.style.display = 'none';
            }

            // Reset the visibility of the adjacent div
            const nextDiv = container.closest('.t4s-sub-menu').querySelector('.t4s-d-block');
            if (nextDiv) {
              nextDiv.style.setProperty('display', 'block', 'important');  // Apply display: block !important
              console.log('Next div with class t4s-d-block is shown:', nextDiv.id);
            }
          }
        });
      });
    });
  }

  // Initial call in case elements are already present
  handleMenuItems();

  // Mutation observer to monitor changes in the image src or data-src
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.attributeName === 'src' || mutation.attributeName === 'data-src') {
        console.log('Image src or data-src attribute changed:', mutation.target.src);
      }
    });
  });

  // Start observing the image container for changes
  const imageContainers = document.querySelectorAll('.mega-menu-image-container');
  imageContainers.forEach(container => {
    const imageElement = container.querySelector('img');
    if (imageElement) {
      observer.observe(imageElement, { attributes: true });
    }
  });
});


/*document.addEventListener('DOMContentLoaded', function() {
  // Select all product images within the gallery
  var galleryItems = document.querySelectorAll('[data-t4s-gallery] img');
  
  // Ensure there are at least two images to swap
  if (galleryItems.length > 1) {
    // Swap the first image with the second one
    var firstImageSrc = galleryItems[0].getAttribute('src');
    galleryItems[0].setAttribute('src', galleryItems[1].getAttribute('src'));
    galleryItems[1].setAttribute('src', firstImageSrc);
  }
});*/


document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        // Select all thumbnail elements
        const thumbnails = document.querySelectorAll('.t4s-carousel__nav-item');
        const thumbnailCount = thumbnails.length;

        // Check how many thumbnails are available
        //if (thumbnailCount === 3) {
            // Click the third thumbnail (index 2)
        if (thumbnailCount > 0) {
          //console.log('There are %s thumbnails', thumbnailCount);
          //console.log(thumbnails[thumbnailCount-1]);
          thumbnails[thumbnailCount-1].click();
        }
        //} else if (thumbnailCount === 2) {
            // Click the second thumbnail (index 1)
        //    thumbnails[1].click();
        //}
        // If there's only one image (or zero), no action is needed
    }, 100); // 2000 ms = 2 seconds delay
});



document.addEventListener("DOMContentLoaded", function() {
    // Find the anchor element that contains the text "My Gift Cards"
    const giftCardLink = document.querySelector('.gifthero-mycards');
    
    // Check if the element exists
    if (giftCardLink) {
      // Change the text to "Gift Card"
      giftCardLink.textContent = "Gift Card";
      
      // Remove the inline style
      giftCardLink.removeAttribute('style');
      
      // Update the href URL
      giftCardLink.setAttribute('href', 'https://fineprintco.com/a/gc/gift-card/balance/');
    }
  });



